import api from './api';

export interface Entidade {
    id: number;
    nome: string;
    documento?: string;
    tipo: 'cliente' | 'fornecedor' | 'ambos';
    asaas_id?: string | null;
}

export const entidadesService = {
    list: async (tipo?: string) => {
        const response = await api.get<Entidade[]>('/entidades', { params: { tipo } });
        return response.data;
    },
    create: async (data: Partial<Entidade>) => {
        const response = await api.post<Entidade>('/entidades', data);
        return response.data;
    },
    update: async (id: number, data: Partial<Entidade>) => {
        const response = await api.put<Entidade>(`/entidades/${id}`, data);
        return response.data;
    },
    delete: async (id: number) => {
        await api.delete(`/entidades/${id}`);
    }
};
